import { Form, Input } from "antd";
import React, { useCallback, useState } from "react";
import { LoadingOutlined } from "@ant-design/icons";
import { useForm } from "antd/lib/form/Form";
import PrimaryButton from "../../ui/buttons/PrimaryButton";
import { apiCall, apiUrls } from "../../store/api";
import "./skillz-admin.scss";

type SkillzAdminLoginProps = {
  onLogin: (token: string) => void;
};

const SkillzAdminLogin = ({ onLogin }: SkillzAdminLoginProps) => {
  const [form] = useForm();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const onSubmit = useCallback(
    async (loginData: { username: string; password: string }) => {
      setIsLoading(true);
      setError(null);
      try {
        const response = await apiCall({
          method: "post",
          url: apiUrls.skillzAdminAuth,
          data: loginData,
        });
        const token = response.data;
        if (!token) {
          throw new Error("Empty token");
        }
        onLogin(token);
      } catch (err) {
        setError("Invalid username or password");
      } finally {
        setIsLoading(false);
      }
    },
    [onLogin]
  );

  return (
    <div className="skillz-admin">
      <div className="skillz-admin__form-wrapper">
        {isLoading && (
          <div className="skillz-admin__loading">
            <LoadingOutlined />
          </div>
        )}
        <Form form={form} onFinish={onSubmit} className="skillz-admin__form">
          <Form.Item name="username" rules={[{ required: true }]}>
            <Input type="text" placeholder="Username" />
          </Form.Item>
          <Form.Item name="password" rules={[{ required: true }]}>
            <Input.Password placeholder="Password" />
          </Form.Item>
          {error && <div className="skillz-admin__error">{error}</div>}
          <Form.Item>
            <PrimaryButton type="primary" htmlType="submit">
              Login
            </PrimaryButton>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
};

export default SkillzAdminLogin;
